<template>
  <div class="footer">
    <div class="left">
      Copyright 2018. Songback LLC. All Rights Reserved.
    </div>
    <div>
      <router-link :to="{name: 'site-about'}" class="fl">About</router-link>
      <router-link :to="{name: 'site-tos'}" class="fl">Terms of Use</router-link>
      <router-link :to="{name: 'site-dmca'}" class="fl">Copyright</router-link>
      <router-link :to="{name: 'site-fees'}" class="fl">Fees and Payments</router-link>
      <router-link :to="{name: 'site-privacy'}" class="fl">Privacy</router-link>
      <router-link :to="{name: 'site-press'}" class="fl">Press</router-link>
    </div>
    <div class="empty">
      &nbsp;
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .footer {
    font-size: 0.8em;
    padding: 1em;
    background-color: $dark-two;
    border-top: 1px solid $dark;
    text-align: left;
    color: $steel;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;

    div {
      flex: 1;
      text-align: center;

      &.empty {
        display: none;
      }
    }

    @include media-breakpoint-up(xl) {
      flex-direction: row;

      div.left {
        text-align: left;
      }

      div.empty {
        display: block;
      }
    }

    .fl {
      color: $steel;
      border-left: 1px solid $steel;
      padding: 0 0.4em 0 0.5em;

      &:nth-child(1) {
        border: 0;
        padding-left: 0;
      }
      &:hover {
        color: white;
        text-decoration: underline;
      }
    }
  }

</style>

<script>
export default {
  name: 'Footer',
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Footer.vue